import { gql } from "@apollo/client";

export default {
  subscription: {
    name: "subscription",
    serviceName: "graphql",
    query: gql`
      mutation subscription(
        $cellphone: String
        $token: String!
        $zone: String
      ) {
        subscription(cellphone: $cellphone, token: $token, zone: $zone) {
          messages
        }
      }
    `,
  },
};
